import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../config/app.config';

/**
 * Protects routes: redirect to login if not authenticated.
 * allowedRoles: optional array of role strings; if provided, user.role must be in allowedRoles.
 */
export function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null; // or <LoadingFallback />; parent Suspense may show fallback for lazy
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (allowedRoles?.length && (!user?.role || !allowedRoles.includes(user.role))) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
}
